import { useTranslation } from 'react-i18next'
import { Inbox, Image, FileText, Link2, Archive } from 'lucide-react'
import { TabButton } from '@meno/ui/components/shared/TabButton'

// Tab strip shared by MediaPage (All / Media / Documents / Links / Archive).
// Audio lives in the Audio Hub now, so it no longer appears here. All tabs are
// hosted in MediaPage and switch via local state, so callers pass an
// `onLocalChange` to handle them.
export type AssetTabKey = 'all' | 'media' | 'documents' | 'links' | 'archive'

type Props = {
  /** Which tab is currently active. */
  active: AssetTabKey
  /** Called when the user clicks one of the tabs. */
  onLocalChange?: (tab: AssetTabKey) => void
  /** Optional badge counts shown next to each tab label. */
  allCount?: number
  mediaCount?: number
  docCount?: number
  linkCount?: number
  archiveCount?: number
}

export default function AssetTabs({
  active, onLocalChange,
  allCount, mediaCount, docCount, linkCount, archiveCount,
}: Props) {
  const { t } = useTranslation()

  const goLocal = (tab: AssetTabKey) => {
    onLocalChange?.(tab)
  }

  return (
    <div className="-mx-4 sm:-mx-[var(--space-l)] -mt-1 sm:-mt-[calc(var(--space-l)-0.75rem)] mb-0 px-4 sm:px-[var(--space-l)] border-b border-border bg-transparent">
      {/* Scrolls sideways on a phone instead of widening the page. */}
      <div className="flex gap-1 overflow-x-auto no-scrollbar [&>*]:shrink-0">
        <TabButton active={active === 'all'}       onClick={() => goLocal('all')}       icon={Inbox}    label={t('assets.tabs.all', 'All')} badge={allCount || undefined} />
        <TabButton active={active === 'media'}     onClick={() => goLocal('media')}     icon={Image}    label={t('assets.tabs.media', 'Media')} badge={mediaCount || undefined} />
        <TabButton active={active === 'documents'} onClick={() => goLocal('documents')} icon={FileText} label={t('assets.tabs.documents', 'Documents')} badge={docCount || undefined} />
        <TabButton active={active === 'links'}     onClick={() => goLocal('links')}     icon={Link2}    label={t('assets.tabs.links', 'Webpages')} badge={linkCount || undefined} />
        <TabButton active={active === 'archive'}   onClick={() => goLocal('archive')}   icon={Archive}  label={t('assets.tabs.archive', 'Archive')} badge={archiveCount || undefined} />
      </div>
    </div>
  )
}
